<template>
  <div class="empty-location-page"
       :class="locationStyles">
    <div class="location">
      <div v-if="$mq !== 'mobile'"
           class="location-icon">
        <icon-location :width="this.$mq === 'mobile' ? '50' : '100'"
                       :height="this.$mq === 'mobile' ? '50' : '100'"
                       iconColor="#8067b7" />
      </div>
    </div>

    {{ $t("noLocationsYet") }}

    <base-button class="retry-button"
                 :loading="loading"
                 color="primary"
                 @click="$emit('retry')">
      {{ $t("tabs.tapToRetry") }}
    </base-button>
  </div>
</template>

<script>
  export default {
    props: {
      loading: {
        required: true,
        type: Boolean
      }
    },

    computed: {
      locationStyles() {
        return {
          'empty-location-page-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .empty-location-page {
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .location {
      text-align: center;

      &-icon {
        background: color.adjust(map.get($colors, primary), $lightness: 40%);

        padding: 50px;
        margin-bottom: 20px;
        border-radius: 50%;

        display: flex;
        justify-content: center;
      }
    }

    .retry-button {
      margin: 12px auto;
    }
  }

  .empty-location-page-mobile {
    .location {
      &-icon {
        padding: 40px;
        margin-bottom: 10px;
      }

      .retry-button {
        margin: 10px auto;
      }
    }
  }
</style>
